import React, { useState } from "react";
import Reaptcha from "reaptcha";
import { Container, Card, Col, Form, Button, Row } from "react-bootstrap";
import * as styles from "./formPrime.module.css";
import Stores from "../components/stores";
import axios from "axios";

const FormPrime = (data) => {
  const [validated, setValidated] = useState(false);
  const [loader, setLoader] = useState(false);
  const [congrats, setCongrats] = useState(false);
  const [error, setError] = useState(false);
  const [disButton, setdisButton] = useState(true);

  const [values, setValues] = useState({
    name: "",
    lastname: "",
    lastname2: "",
    email: "",
    confirm: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };
  const onVerify = (recaptchaResponse) => {
    document.querySelector("#formButton").disabled = false;
    setdisButton(false);
  };
  const handleSubmit = (event) => {
    const button = document.querySelector("#formButton");
    event.preventDefault();
    setValidated(true);

    if (
      values.email === values.confirm &&
      document.querySelector("#formPrime").checkValidity()
    ) {
      button.disabled = true;
      setLoader(true);
      values.campaign = data.campaign;
      axios({
        method: "post",
        url: "https://api.casham.app/invitation/prime",
        data: values,
      })
        .then((response) => {
          setLoader(false);
          setCongrats(true);
          window.gtag("event", "conversion", {
            send_to: "AW-607744627/prrNCPmB7t0BEPPk5aEC",
          });
        })
        .catch((err) => {
          console.error(err);
          setLoader(false);
          setError(true);
        });
    }
  };
  return (
    <>
      <Card>
        <Card.Body>
          <div className="secondary-headings">
            Obtén tu código de invitación aquí.
          </div>
          <div className="general-text">
            1.- Llena el formulario, te enviaremos un código de invitación a tu
            correo electrónico.
          </div>
          <Container>
            {loader && <div className={styles.loader}></div>}
            {!loader && !congrats && (
              <Form id="formPrime" noValidate validated={validated}>
                <Row>
                  <Form.Group
                    className="mb-3"
                    as={Col}
                    md="4"
                    controlId="validationCustom01"
                  >
                    <Form.Control
                      name="lastname"
                      required
                      type="text"
                      placeholder="Apellido Paterno"
                      value={values.lastname}
                      onChange={handleInputChange}
                    />
                    <Form.Control.Feedback></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      Apellido Paterno es obligatorio.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group
                    className="mb-3"
                    as={Col}
                    md="4"
                    controlId="validationCustom02"
                  >
                    <Form.Control
                      name="lastname2"
                      required
                      type="text"
                      placeholder="Apellido Materno"
                      value={values.lastname2}
                      onChange={handleInputChange}
                    />
                    <Form.Control.Feedback></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      Apellido Materno es obligatorio.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group
                    className="mb-3"
                    as={Col}
                    md="4"
                    controlId="validationCustomUsername"
                  >
                    <Form.Control
                      name="name"
                      value={values.name}
                      onChange={handleInputChange}
                      required
                      type="text"
                      placeholder="Nombre(s)"
                    />
                    <Form.Control.Feedback></Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      Nombre(s) es obligatorio.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group
                    className="mb-3"
                    as={Col}
                    md="6"
                    controlId="validationCustom03"
                  >
                    <Form.Control
                      name="email"
                      type="email"
                      placeholder="Correo electrónico"
                      required
                      value={values.email}
                      onChange={handleInputChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Correo electrónico es obligatorio.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group
                    className="mb-3"
                    as={Col}
                    md="6"
                    controlId="validationCustom03"
                  >
                    <Form.Control
                      name="confirm"
                      type="email"
                      required
                      placeholder="Confirmación correo electrónico"
                      isInvalid={values.email !== values.confirm}
                      value={values.confirm}
                      onChange={handleInputChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      No coinciden el correo.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Reaptcha
                  sitekey="6Ld7ztAZAAAAADsLYnBUahTuckIUYGsX_LwDwRUa"
                  onVerify={onVerify}
                />
                <Button
                  onClick={handleSubmit}
                  variant="success"
                  className={styles.button}
                  disabled={disButton}
                  id="formButton"
                >
                  ¡Obtener código!
                </Button>
              </Form>
            )}
            {congrats && (
              <h3>
                Tu codigo a sido enviado a {values.email}. Si no encuentras tu
                invitación te recomendamos revisar tu bandeja de correo no
                deseado "SPAM". Asegura la recepción marcando nuestro correo
                como seguro.
              </h3>
            )}
            {error && (
              <div className={styles.error}>
                Ocurrio un error intenta mas tarde.
              </div>
            )}
          </Container>
          <div className="general-text">
            2.- Descarga nuestra app de tu tienda favorita, usa tu código para
            llenar la solicitud y acepta nuestros términos de servicio.
            <div className={styles.store}>
              <Stores></Stores>
            </div>
          </div>
          <div className="general-text">3.- Paga tu cuota de suscripción y solicita tu primer préstamo.</div>
          <div className="general-text">
            4.- ¡Emprende tu viaje hacia un mejor futuro financiero!
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default FormPrime;
